import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _toConsumableArray from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import defaultTailwindTheme from 'tailwindcss/defaultTheme';
import { blue, green, neutral, purple, red, teal, yellow } from './colors';
import { ProximaNova } from './font';
export var adminBaseTheme = {
  dropShadow: {
    sm: '0 1px 1px rgb(35, 43, 52 / 0.05)',
    DEFAULT: ['0 1px 2px rgb(35, 43, 52 / 0.1)', '0 1px 1px rgb(35, 43, 52 / 0.06)'],
    md: ['0 4px 3px rgb(35, 43, 52 / 0.07)', '0 2px 2px rgb(35, 43, 52 / 0.06)'],
    lg: ['0 10px 8px rgb(35, 43, 52 / 0.04)', '0 4px 3px rgb(35, 43, 52 / 0.1)'],
    xl: ['0 20px 13px rgb(35, 43, 52 / 0.03)', '0 8px 5px rgb(35, 43, 52 / 0.08)'],
    '2xl': '0 25px 25px rgb(35, 43, 52 / 0.15)',
    none: '0 0 #0000'
  },
  boxShadow: {
    sm: '0 1px 2px 0 rgb(35, 43, 52 / 0.05)',
    DEFAULT: '0 1px 3px 0 rgb(35, 43, 52 / 0.1), 0 1px 2px -1px rgb(35, 43, 52 / 0.1)',
    md: '0 4px 6px -1px rgb(35, 43, 52 / 0.1), 0 2px 4px -2px rgb(35, 43, 52 / 0.1)',
    lg: '0 10px 15px -3px rgb(35, 43, 52 / 0.1), 0 4px 6px -4px rgb(35, 43, 52 / 0.1)',
    xl: '0 20px 25px -5px rgb(35, 43, 52 / 0.1), 0 8px 10px -6px rgb(35, 43, 52 / 0.1)',
    '2xl': '0 25px 50px -12px rgb(35, 43, 52 / 0.25)',
    inner: 'inset 0 2px 4px 0 rgb(35, 43, 52 / 0.05)',
    none: 'none'
  },
  extend: {
    fontFamily: {
      sans: [ProximaNova].concat(_toConsumableArray(defaultTailwindTheme.fontFamily.sans))
    },
    colors: {
      neutral: _objectSpread({
        white: '#FFFFFF',
        black: '#000000'
      }, neutral),
      blue: blue,
      purple: purple,
      teal: teal,
      red: red,
      green: green,
      yellow: yellow
    },
    borderColor: {
      DEFAULT: neutral[100]
    },
    ringColor: {
      DEFAULT: blue[500]
    }
  }
};